export const CONFIRMED_GET_ADMIN_USERS = "CONFIRMED_GET_ADMIN_USERS";
export const CONFIRMED_ADD_ADMIN_USER = "CONFIRMED_ADD_ADMIN_USER";
export const CONFIRMED_UPDATE_ADMIN_USER = "CONFIRMED_UPDATE_ADMIN_USER";
export const CONFIRMED_DELETE_ADMIN_USER = "CONFIRMED_DELETE_ADMIN_USER";
